import { MutationTree } from 'vuex'
import { CategoryState } from './types'
import Category from '@/calendesk/models/DTO/Response/Category'

export const mutations: MutationTree<CategoryState> = {
  SET_CATEGORY_AND_SERVICES (state, payload: Category[]) {
    state.categoryAndServices = payload
  }
}
